import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LogService } from '@prekog/common-ui';

import { GetFestivalStatisticRequest } from '../../statistics/festivalstatistic/getfestivalstatistic.request';
import { GetFestivalStatisticResponse } from '../../statistics/festivalstatistic/getfestivalstatistic.response';
import { LoadStatisticsUseCase } from '../../shared/use-cases/load-statistics.usecase';
import { STORE_BACKEND_URL } from 'src/app/app.config';

@Injectable({
    providedIn: 'root'
})
export class LoadFestivalStatisticUseCase extends LoadStatisticsUseCase<GetFestivalStatisticRequest, GetFestivalStatisticResponse> {
    private _storeBaseUrl = inject<string>(STORE_BACKEND_URL);

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override getBackendUrl(): string {
        return this._storeBaseUrl;
    }

    protected override getApiUrl(): string {
        return '/admin/getFestivalStatistics';
    }
}
